import { render } from "./policies-modal.vue?vue&type=template&id=44758c7c"
import script from "./policies-modal.vue?vue&type=script&lang=js"
export * from "./policies-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__